import { commons } from "@/services/requests";
import { useMutation, useQueryClient } from "react-query";

export default function useDeleteCart() {
  const queryClient = useQueryClient();

  const { mutate: deleteCard, isLoading: isLoadingDeleteCard } = useMutation(
    (id: number) => commons.deleteCard(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["BASKET"]);
      },
    }
  );

  return { deleteCard, isLoadingDeleteCard };
}
